import type { TypedMyHotelDetail } from './-MyHotelDetail';
import RawMyHotelDetail from './MyHotelDetail.vue';
export * from './-MyHotelDetail';
export const MyHotelDetail = RawMyHotelDetail as typeof TypedMyHotelDetail;
